import { z } from 'zod';

import { nonEmptyParamValidator } from '../../validators';
import { PaginationQuerySchema } from '../pagination';

export const LearningTopicsQuerySchema = z
  .object({
    q: nonEmptyParamValidator('q').optional(),
  })
  .merge(PaginationQuerySchema);

export type ILearningTopicsQueryDto = z.infer<typeof LearningTopicsQuerySchema>;
